import { gql } from "graphql-request";

const UpdateSupplierQuery = gql`
  mutation UpdateSupplier($updateSupplierId: Int!, $data: SupplierUpdateDto!) {
    UpdateSupplier(id: $updateSupplierId, data: $data) {
      status
      error
      messege
      data
    }
  }
`;
export default UpdateSupplierQuery;
